import { Component, Input } from '@angular/core';
import { MartOrderDetailsComponent } from 'app/mart';

@Component({
    selector: 'mart-order-details-products-tab',
    templateUrl: './mart-order-details-products-tab.component.html',
    styleUrls: [
        './mart-order-details-products-tab.component.scss',
        '../mart-order-details.component.scss'
    ]
})
export class MartOrderDetailsProductsTabComponent {
    @Input()
    public parent!: MartOrderDetailsComponent;
}
